// core
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IconButton, Tooltip } from '@material-ui/core';
import CopyIcon from '@material-ui/icons/FileCopy';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';

import * as actions from '../../../../state';
import { copyBoard } from '../../../../events';

const messages = defineMessages({
  COPY_BOARD: {
    id: 'COPY_BOARD',
    defaultMessage: 'Copy board',
  },
  COPY: {
    id: 'COPY',
    defaultMessage: 'COPY',
  },
  BOARD_COPIED: {
    id: 'BOARD_COPIED',
    defaultMessage: 'Board copied.',
  },
  BOARD_LINK_TEXT: {
    id: 'BOARD_LINK_TEXT',
    defaultMessage: 'Go to board.',
  },
});

function CopyBoardBtn({ intl }) {
  const dispatch = useDispatch();

  const board = useSelector(actions.readStateBoard);
  const charts = useSelector(actions.readStateCharts);

  return (
    <Tooltip disableFocusListener title={<FormattedMessage {...messages.COPY_BOARD} />}>
      <IconButton onClick={() => dispatch(copyBoard(board, charts, intl, messages))}>
        <CopyIcon />
      </IconButton>
    </Tooltip>
  );
}

export default injectIntl(CopyBoardBtn);
